import { ToggleButtonGroup, ToggleButton } from "@mui/material";

export default function SegmentControl({ className = "", segmentOptions, value, ...otherProps }) {
  return (
    <ToggleButtonGroup className={`segment-control ${className}`} value={value} {...otherProps}>
      {segmentOptions.map((option, idx) => (
        <ToggleButton key={idx} value={option.value} selected={value === option.value}>
          {!!option.Icon && <option.Icon className="icon" />}
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
